<template>
  <div>
    <div class="content-title-box" :class="centered?'':'ta_l'">
      {{text}}
      <div class="content-title-border" :class="centered?'':'left_17'"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    text: String,
    centered: {
      type: Boolean,
      default: true,
    },
  },
  components: {},

  methods: {},
};
</script>
<style scoped>
.content-title-box {
  line-height: 45px;
  font-size: 28px;
  position: relative;
  text-align: center;
  color: #1f2329;
    font-family: 'PingFang-Bold';
}

.ta_l {
  text-align: left !important;
}

.left_17 {
  left: 17px !important;
}

.content-title-border {
  position: absolute;
  width: 32px;
  height: 4px;
  background-color: #0050a7;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  bottom: -15%;
}
</style>